import { render, staticRenderFns } from "./FundMixChart.vue?vue&type=template&id=34be7ba1&"
import script from "./FundMixChart.vue?vue&type=script&lang=ts&"
export * from "./FundMixChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports